import {
  postingTemplateListResponseSchema,
  postingTemplateSchema,
  postingTemplateUpsertSchema,
  type PostingTemplateUpsertRequest,
} from "@chotca/config";
import { z } from "zod";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

export function createPostingTemplatesResource(ctx: RequestContext) {
  return {
    list(orgId: string) {
      return requestJson(ctx, {
        method: "GET",
        path: `/orgs/${orgId}/posting-templates`,
        dataSchema: postingTemplateListResponseSchema,
        auth: true,
      });
    },
    create(orgId: string, body: PostingTemplateUpsertRequest) {
      const payload = postingTemplateUpsertSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: `/orgs/${orgId}/posting-templates`,
        body: payload,
        dataSchema: postingTemplateSchema,
        auth: true,
      });
    },
    update(
      orgId: string,
      templateId: string,
      body: PostingTemplateUpsertRequest,
    ) {
      const payload = postingTemplateUpsertSchema.parse(body);
      return requestJson(ctx, {
        method: "PATCH",
        path: `/orgs/${orgId}/posting-templates/${templateId}`,
        body: payload,
        dataSchema: postingTemplateSchema,
        auth: true,
      });
    },
    remove(orgId: string, templateId: string) {
      return requestJson(ctx, {
        method: "DELETE",
        path: `/orgs/${orgId}/posting-templates/${templateId}`,
        dataSchema: z.object({ ok: z.literal(true) }),
        auth: true,
      });
    },
  };
}
